import axios from 'axios'
import {handleError} from '@/utils/HttpErrorHandler'
import Vue from 'vue'
import store from '@/store'

const responsesWithCustomMessageHandlers = [
  'login',
  'password/create',
  'password/forgot',
  'register',
  'account/activate',
  'account/delete',
  'rewards',
  'messages',
  'goals/donate',
  'push/token/exists'
];

function shouldHandleMessage(url) {
  for (let i = 0; i < responsesWithCustomMessageHandlers.length; i++) {
    if (url.includes(responsesWithCustomMessageHandlers[i])) {
      return false;
    }
  }

  return true;
}

const http = axios;
http.defaults.baseURL = process.env.VUE_APP_API_URI;
http.interceptors.response.use(
  (r) => {
    if (r.data.hasOwnProperty('userVersion')) {
      store.dispatch('setUserVersion', r.data.userVersion);
    }

    if (shouldHandleMessage(r.request.responseURL) && r.data.hasOwnProperty('message')) {
      Vue.$notify(
        r.data.message,
        (r.data.success) ? 'info' : 'warning'
      )
    }

    return Promise.resolve(r)
  },
  (e) => {
    handleError(e);
    return Promise.reject(e)
  }
);

export default http;
